/* src/app/home/home.component.scss */
.brand-background {
  background: url(/assets/img/background.jpg) no-repeat center;
  min-height: 100vh;
}
/*# sourceMappingURL=home.component.css.map */
